import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';
import { ModalCondicionesComponent } from '../modal-condiciones/modal-condiciones.component';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  public formChange: FormGroup;
  public loader = {
    change: false
  };
  error;
  infoUsuario;
  dialogRef: MatDialogRef<ModalCondicionesComponent>;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private _authService: AuthService,
    public dialog: MatDialog,
  ) {

    this.formChange = this.fb.group({
      pwActual: ['', [Validators.required]],
      pwNueva: ['', [Validators.required]],
      confirmaPw: ['', [Validators.required]]
    });

    this.error = {
      status: false,
      descripcion: ""
    };

    this.infoUsuario = JSON.parse(localStorage.getItem('usuario'));
   }

  ngOnInit(): void {
  }

  public get f() {
    return this.formChange.controls;
  }

  validaConfirmacion(){
    let pw = this.formChange.get('pwNueva').value;
    let newPw = this.formChange.get('confirmaPw').value;
    if(pw === newPw){
      return true;
    }else{
      return false;
    }
  }

  async openDialog() {
    this.dialogRef = this.dialog.open(ModalCondicionesComponent, {
      height: "820px",
      width: "600px"
    });

    this.dialogRef.beforeClosed().subscribe(async (result) => {
      if (result && result.status) {
        if(result.aceptaTerminos){
          const req = {
            token: this.infoUsuario.token,
            claveAntigua: this.formChange.get('pwActual').value,
            claveNueva: this.formChange.get('pwNueva').value
          };
          try{
            const response = await this._authService.cambiarClave(req);
            if( response.error.codError == 0){
              let tipo = JSON.parse(localStorage.getItem('usuario')).usuario.tipo;
              if( tipo == 'ENEX' ){
                this.router.navigate(['ejecutivo']);
              }else{
                this.router.navigate(['main']);
              }
            } else{
              console.log("Error al cambiar la clave: ", response.error);
            }
      
          }catch(error){
            console.log("Error al cambiar la clave ", error);
            this.error = {
              status: true,
              descripcion: "Error al intentar cambiar la clave, intente nuevamente"
            };
          }
        }
      } else{
        this.router.navigate(['/auth']);
      }
    });
  }
}
